const { createElem } = require('./helperFunctions');

class SideNavigation {
  constructor() {
    this.navElem = document.querySelector('.top-nav .left-nav');
    this.subMenuParents = [...document.querySelectorAll('.top-nav .has-children')];
    this.searchElem = document.querySelector('.top-nav .search-container');
  }

  // eslint-disable-next-line consistent-return
  getElem(elem) {
    if (elem !== null) {
      return elem.parentElement.removeChild(elem);
    }
  }

  buildSearchHtml() {
    const frag = document.createDocumentFragment();

    const navSearch = this.getElem(this.searchElem);
    navSearch.classList.add('hub-nav--search');

    const searchInput = navSearch.querySelector('.search-input');
    const searchLabel = createElem('label', { class: 'visually-hidden', for: 'q' }, 'Search');
    searchInput.insertBefore(searchLabel, searchInput.firstChild);

    frag.appendChild(navSearch);

    return frag;
  }

  createASubscriberNote() {
    console.log('test');
    //add a label after the search field
    const subscriberNoteContainer = document.querySelector('.hub-nav--search');
    if(subscriberNoteContainer) {
      const subscriberNote = document.createElement('div');
      subscriberNote.setAttribute('class', 'subscriber-note');
      subscriberNote.innerHTML = 'Subscribe to Our Monthly Content Roundup';
      subscriberNote.setAttribute('style', 'display:none');
      subscriberNoteContainer.appendChild(subscriberNote);
      
       return subscriberNoteContainer;
    } else {
        throw ReferenceError("id not found");
    }
    
 }

  buildItemContentHtml() {
    const itemContentContainer = createElem('div', { class: 'ob-item-content-container' });
    const defaultItemContentContainer = document.querySelector('#item-content');
    const breadcrumb = document.querySelector('.bread-crumbs');
    const textContent = document.querySelector('.item-data');
    const relatedItemsContainer = document.querySelector('.related-items-container');

    if (defaultItemContentContainer) {
      defaultItemContentContainer.insertBefore(itemContentContainer, breadcrumb);
      itemContentContainer.appendChild(breadcrumb);
      itemContentContainer.appendChild(textContent);
      itemContentContainer.appendChild(relatedItemsContainer);
    }
  }

  buildNavHtml() {
    const frag = document.createDocumentFragment();

    const navWrapper = createElem('div', { class: 'hub-nav hub-nav--wrapper' });
    const navList = this.getElem(this.navElem);
    navList.setAttribute('class', 'hub-nav--nav');
    const formContainer = createElem('div', { class: 'ob-marketo-form-container' });
    const form = createElem('form', { id: 'mktoForm_1852' });

    // remove target blank from hub nav for item level
    const itemLinks = navList.querySelectorAll('a');
    itemLinks.forEach((link) => {
      link.setAttribute('target', '_self');
    });

    navWrapper.appendChild(navList);
    if (window.innerWidth >= 861) {
      navWrapper.appendChild(this.buildSearchHtml());
    }
    formContainer.appendChild(form);
    navWrapper.appendChild(formContainer);
    frag.appendChild(navWrapper);

    return frag;
  }

  loadMarketoForm() {
    const formContainer = document.querySelector('.ob-marketo-form-container');

    if (formContainer) {
      // eslint-disable-next-line no-undef
      MktoForms2.loadForm('//app-ab07.marketo.com', '958-TTM-744', 1852);
      // eslint-disable-next-line no-undef
      MktoForms2.whenReady(() => {
        const emailInput = formContainer.querySelector('input#Email');

        emailInput ? emailInput.setAttribute('placeholder', 'your email') : null;
      });
    }
  }

  moveSearchInput() {
    const sideHubNav = document.querySelector('.hub-nav--wrapper');
    const searchContainer = document.querySelector('.hub-nav--search');
    const hubNavSearchContainer = document.querySelector('.relativeDiv--search');
    const marketoForm = document.querySelector('.ob-marketo-form-container');

    if (searchContainer) {
      if (window.innerWidth <= 860) {
        hubNavSearchContainer.insertBefore(searchContainer, hubNavSearchContainer.firstChild);
      } else if (window.innerWidth >= 861) {
        sideHubNav.insertBefore(searchContainer, marketoForm);
      }
    } else if (!searchContainer) {
      if (window.innerWidth >= 861) {
        sideHubNav.insertBefore(this.buildSearchHtml(), marketoForm);
      }
    }
  }

  toggleSubMenu() {
    const subMenuElement = this.querySelector('ul');

    if (this.classList.contains('active')) {
      this.classList.remove('active');

      if (window.innerWidth >= 861) {
        $(subMenuElement).slideToggle(300);
      }
    } else {
      if (window.innerWidth >= 861) {
        $(subMenuElement).slideToggle(300);
      } else {
        const openMenu = document.querySelector(`li.active`);
        openMenu ? openMenu.classList.remove('active') : null;
      }

      this.classList.toggle('active');
    }
  }

  closeAllSubMenus() {
    for (let i = 0; i < this.subMenuParents.length; i++) {
      const currentMenu = this.subMenuParents[i].parentElement;
      if (currentMenu.classList.contains('active')) {
        currentMenu.classList.remove('active');
        currentMenu.querySelector('ul').setAttribute('style', 'display: none;');
      }
    }
  }

  resizeListener() {
    let lastWindowWidth;

    window.addEventListener('resize', (e) => {
      const currentWindowWidth = window.innerWidth;
      if (lastWindowWidth > 861 && currentWindowWidth < 861) {
        this.closeAllSubMenus();
      }
      lastWindowWidth = currentWindowWidth;

      this.moveSearchInput();
    });
  }

  clickListener() {
    for (let i = 0; i < this.subMenuParents.length; i++) {
      this.subMenuParents[i].addEventListener('click', this.toggleSubMenu);
    }
  }

  init() {
    // any page with a grid
    const hubNav = document.querySelector('.top-nav');
    const gridPageTarget = document.querySelector('.level-two');
    const itemPageTarget = document.querySelector('#item-content');
    const itemLevel = document.body.classList.contains('single-page');

    if (!itemLevel && hubNav) {
      if (!gridPageTarget) {
        throw new ReferenceError('Could not append navigation');
      }

      gridPageTarget.insertBefore(this.buildNavHtml(), gridPageTarget.firstChild);
    } else if (itemLevel && hubNav) {
      if (!itemPageTarget) {
        throw new ReferenceError('Could not append navigation');
      }

      this.buildItemContentHtml();
      itemPageTarget.insertBefore(this.buildNavHtml(), itemPageTarget.firstChild);
    }

    this.loadMarketoForm();
    this.clickListener();
    this.resizeListener();
    this.createASubscriberNote();

    return this;
  }
}

const addSideNav = () => {
  const sideNav = new SideNavigation();
  sideNav.init();
};

module.exports = { addSideNav };



// WEBPACK FOOTER //
// ./scriptPartials/leftSideNav.js